import { render, staticRenderFns } from "./tabselect.vue?vue&type=template&id=646895a7&"
import script from "./tabselect.vue?vue&type=script&lang=js&"
export * from "./tabselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports